import styled from 'styled-components'
import Comment from '../../iconsV2/Comment'
import AddStock from '../../iconsV2/AddStock'
import Disposal from '../../iconsV2/Disposal'
import StockCount from '../../iconsV2/StockCount'
import Administration from '../../iconsV2/Administration'
import { Text } from '@lmc/ui-kit/src/general'
import { MedicationStockReason } from '../../types'

interface ActionCellProps {
  type: MedicationStockReason
  title: string
  subtitle?: string
  hasDiscrepancy?: boolean
}

const renderActionIcon = (type: MedicationStockReason) => {
  switch (type) {
    case MedicationStockReason.STOCK_COUNT:
    case MedicationStockReason.RECONCILIATION:
    case MedicationStockReason.INITIAL_STOCK:
      return <StockCount />
    case MedicationStockReason.DISPOSAL:
      return <Disposal />
    case MedicationStockReason.RESTOCK:
      return <AddStock />
    case MedicationStockReason.MED_ADMIN:
      return <Administration />
    case MedicationStockReason.NOT_ADMINISTERED:
      return <Comment />
    default:
      return <StockCount />
  }
}

const ActionCell = ({ type, title, subtitle }: ActionCellProps) => {
  return (
    <ActionCellContainer>
      <IconContainer>{renderActionIcon(type)}</IconContainer>
      <TextContainer>
        <Title>{title}</Title>
        {subtitle && <Subtitle level={2}>{subtitle}</Subtitle>}
      </TextContainer>
    </ActionCellContainer>
  )
}

const ActionCellContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

const Title = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  line-height: 1;
`

const Subtitle = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

export default ActionCell
